<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.729 9.713a1.008 1.008 0 012.016 0v2.016h2.017a1.008 1.008 0 010 2.016h-2.017v2.017a1.008 1.008 0 01-2.016 0v-2.017H9.713a1.008 1.008 0 110-2.016h2.016V9.713z"/><path fill-rule="evenodd" d="M21.474 12.737a8.7 8.7 0 01-1.887 5.424l8.118 8.118a1.008 1.008 0 11-1.426 1.426l-8.118-8.118a8.737 8.737 0 113.313-6.85zm-8.737 6.721a6.721 6.721 0 100-13.442 6.721 6.721 0 000 13.442z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsZoomInOutline'
}
</script>
